import React, { useState } from "react";

const BACCalculator = ({ tezina, pol }) => {
  const [weight, setWeight] = useState(tezina);
  const [hours, setHours] = useState("");
  const [gender, setGender] = useState(pol);
  const [drinks, setDrinks] = useState([{ type: "beer", volume: 500 }]);
  const [foodConsumption, setFoodConsumption] = useState("none");
  const [bac, setBac] = useState(null);

  const alcoholContent = {
    beer: 0.05, // 5% alcohol by volume (ABV)
    wine: 0.12, // 12% ABV
    spirits: 0.4, // 40% ABV
  };

  const handleDrinkChange = (index, key, value) => {
    const updatedDrinks = [...drinks];
    updatedDrinks[index][key] = value;
    setDrinks(updatedDrinks);
  };

  const handleAddDrink = () => {
    setDrinks([...drinks, { type: "beer", volume: 500 }]);
  };

  const handleCalculate = () => {
    // Check for missing inputs
    if (!weight) {
      alert("Molimo unesite težinu.");
      return;
    }
    if (!hours) {
      alert("Molimo unesite proteklo vreme.");
      return;
    }

    let totalAlcoholConsumed = 0;

    // Calculate alcohol consumed based on drink type and volume
    drinks.forEach((drink) => {
      const alcoholPerDrink = drink.volume * alcoholContent[drink.type]; // volume in ml * alcohol percentage
      totalAlcoholConsumed += alcoholPerDrink; // grams of alcohol
    });

    const bodyWaterConstant = gender === "muski" ? 0.58 : 0.49;
    const metabolismRate = gender === "muski" ? 0.015 : 0.017;

    // Adjust for food consumption (slows absorption rate)
    const absorptionRate =
      foodConsumption === "heavy"
        ? 0.8
        : foodConsumption === "light"
        ? 0.9
        : 1.0;

    // Calculate BAC
    const bacValue =
      ((totalAlcoholConsumed * 0.789) / (weight * bodyWaterConstant)) *
        absorptionRate *
        100 -
      metabolismRate * hours;

    setBac(Math.max(bacValue, 0).toFixed(3)); // Ensure BAC is not negative, rounded to 3 decimals
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md border border-gray-500">
      <h1 className="text-3xl font-bold text-gray-800 text-center">
        Precizan BAC Kalkulator
      </h1>
      <h4 className="text-gray-800 text-center mb-6">
        (Koncentracija alkohola u krvi)
      </h4>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Težina (kg)
      </label>
      <input
        type="number"
        placeholder="Težina (kg)"
        value={weight}
        onChange={(e) => setWeight(e.target.value)}
        className="border border-gray-300 rounded-lg p-3 w-full mb-4"
      />
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Vreme (h)
      </label>
      <input
        type="number"
        placeholder="Proteklo vreme (h)"
        value={hours}
        onChange={(e) => setHours(e.target.value)}
        className="border border-gray-300 rounded-lg p-3 w-full mb-4"
      />
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Pol
        </label>
        <select
          value={gender}
          onChange={(e) => setGender(e.target.value)}
          className="border border-gray-300 rounded-lg p-3 w-full"
        >
          <option value="zenski">Žensko</option>
          <option value="muski">Muško</option>
        </select>
      </div>
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Konzumacija hrane
        </label>
        <select
          value={foodConsumption}
          onChange={(e) => setFoodConsumption(e.target.value)}
          className="border border-gray-300 rounded-lg p-3 w-full"
        >
          <option value="none">Nema</option>
          <option value="light">Lagani obrok</option>
          <option value="heavy">Teški obrok</option>
        </select>
      </div>

      <div className="mb-4">
        <h3 className="text-lg font-semibold mb-2">Konzumirana pića:</h3>
        {drinks.map((drink, index) => (
          <div key={index} className="flex space-x-4 mb-4">
            <select
              value={drink.type}
              onChange={(e) => handleDrinkChange(index, "type", e.target.value)}
              className="border border-gray-300 rounded-lg p-3 w-full"
            >
              <option value="beer">Pivo</option>
              <option value="wine">Vino</option>
              <option value="spirits">Žestoka pića</option>
            </select>
            <input
              type="number"
              placeholder="Volumen (ml)"
              value={drink.volume}
              onChange={(e) =>
                handleDrinkChange(index, "volume", e.target.value)
              }
              className="border border-gray-300 rounded-lg p-3 w-full"
            />
          </div>
        ))}
        <button
          onClick={handleAddDrink}
          className="w-full bg-gray-300 text-black rounded-lg py-2 hover:bg-gray-400 transition duration-300"
        >
          Dodaj piće
        </button>
      </div>

      <button
        onClick={handleCalculate}
        className="w-full bg-blue-600 text-white rounded-lg py-3 hover:bg-blue-700 transition duration-300"
      >
        Izračunaj BAC
      </button>

      {bac !== null && (
        <div className="mt-6 text-center">
          <h2 className="text-2xl font-semibold text-gray-800">
            Tvoj BAC: {bac}
          </h2>
        </div>
      )}
    </div>
  );
};

export default BACCalculator;
